if (!customElements.get('izuro-quantity-buttons')) {
  customElements.define('izuro-quantity-buttons', class extends HTMLElement {
    connectedCallback() {
      this.onChange = () => this.updatePrice();
      this.addEventListener('change', this.onChange);
      // Forms and payment buttons use these real form-associated quantity radios.
      // No option-value event is published and the underlying item ID stays fixed.
      this.updatePrice();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
    }

    updatePrice() {
      const form = document.getElementById(this.dataset.formId);
      if (!form) return;
      const button = form.querySelector('[name="add"]');
      if (!button) return;
      const selected = this.querySelector('[data-quantity-choice]:checked:not(:disabled)');
      if (!selected) {
        button.disabled = true;
        return;
      }
      button.dataset.buttonPrice = selected.dataset.totalPrice;
      if (!button.disabled && button.getAttribute('aria-disabled') !== 'true') {
        const label = button.querySelector('span');
        const text = window.variantStrings?.addToCart || 'Add to cart';
        if (label) label.textContent = `${text} · ${selected.dataset.totalPrice}`;
      }
    }
  });
}
